import { render } from "./SingleProject.vue?vue&type=template&id=df77f9c4"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__